import type { IconLine } from '@/scopes/prices/infrastructure/transport/types'
import type { IconGlyph } from '@sunwebgroup/ui-components'
import { TripSummary, TripSummaryItem } from '@/scopes/prices/domain/transports/types'

const ICONS_MAP: Record<string, IconGlyph> = {
  'icon-building': 'IconBuilding',
  'icon-calendar': 'IconCalendar',
  'icon-family': 'IconFamily',
  'icon-flight-outbound': 'IconAirplaneDeparture',
  'icon-flight-inbound': 'IconAirplaneReturn',
  'icon-car': 'IconCarFront',
  'icon-bus': 'IconBusRight',
}

export function mapTripSummary(item: IconLine) {
  const icon = ICONS_MAP[item.icon]
  const headerText = item.lines.find(line => line.isBold)?.text || ''
  const stars = item.lines.find(line => line.isBold)?.metadata?.split(':')[1]
  const extraInfo = item.lines.filter(line => !line.isBold).map(line => line.text)

  return {
    header: {
      icon,
      text: headerText,
      stars: stars ? Number.parseInt(stars) : undefined,
    },
    extraInfo,
  }
}

export function mapBusRouteTripSummary(iconLines: IconLine[]): TripSummary {
  const result: TripSummaryItem[] = []

  for (const iconLine of iconLines) {
    let currentItem: TripSummaryItem | null = null
    for (const line of iconLine.lines) {
      if (line.isBold) {
        currentItem = {
          header: {
            icon: ICONS_MAP[iconLine.icon],
            text: line.text,
          },
          extraInfo: [],
        }
        result.push(currentItem)
      }
      else {
        if (!currentItem) {
          currentItem = {
            header: {
              icon: ICONS_MAP[iconLine.icon],
              text: '',
            },
            extraInfo: [],
          }
          result.push(currentItem)
        }
        currentItem.extraInfo.push(line.text)
      }
    }
  }

  return result
}
